
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categories/[id]/articles",
      function () {
        return require("private-next-pages/categories/[id]/articles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/categories/[id]/articles"])
      });
    }
  